export class ModuleBrandName {
  name: string;

  constructor(params: any = {}) {
    this.name = params.name;
  }
}
